import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type SwapCallRequest = void;

export interface SwapCallRepository {
  fetchTransferCall(): Promise<Call>;
  getCurrentCall(): Promise<Call>;
  updateHoldStatus(id: string, isOnHold: boolean): Promise<void>;
  updateTransferHoldStatus(id: string, isOnHold: boolean): Promise<void>;
}

export interface SwapCallEventPublisher {
  publish(): Promise<void>;
}

export interface SwapCallUsecase extends BaseUsecase<SwapCallRequest, void> {
  run(): Promise<void>;
}

export class SwapCall implements SwapCallUsecase {
  constructor(
    private repository: SwapCallRepository,
    private publisher: SwapCallEventPublisher,
  ) {}

  async run(): Promise<void> {
    const transferCall = await this.repository.fetchTransferCall();
    const currentCall = await this.repository.getCurrentCall();
    if (transferCall) {
      this.repository.updateTransferHoldStatus(
        transferCall.to,
        !transferCall.isOnHold,
      );
    }
    if (currentCall) {
      this.repository.updateTransferHoldStatus(
        currentCall.to,
        !currentCall.isOnHold,
      );
    }
    await Promise.all([this.publisher.publish()]);
  }
}
